import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új szótár adat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'number',
                formVisible: false
            },
            {
                name: "eesztId",
                label: "EESZT ID",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 4,
                formVisible: true
            },
            {
                name: "codeStoreId",
                label: "Kódtár ID",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCodeStoreByTpye,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "text",
                label: "Szöveg",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "oldId",
                label: "ID",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 3,
                formVisible: false,
                visibility: false
            },
            {
                name: "companyId",
                label: "Cég Id",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 6,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
